import { Component, OnInit } from '@angular/core';
import { CommonComponent } from '@components/common.component';
import { crosscuttingActions, selectCrosscutting } from '@redux/crosscutting.redux';
import { AsyncPipe, DecimalPipe, NgIf } from '@angular/common';
import { first } from 'lodash-es';

@Component({
  selector: 'app-weather',
  standalone: true,
  imports: [AsyncPipe, NgIf, DecimalPipe],
  templateUrl: './weather.component.html',
  styleUrl: './weather.component.scss',
})
export class WeatherComponent extends CommonComponent implements OnInit {
  first = first;
  weather$ = this.store.select(selectCrosscutting.selectWeather);
  map: { [key: string]: string } = {
    '01d': 'sunny',
    '01n': 'sunny',
    '02d': 'cloudy',
    '02n': 'cloudy',
    '03d': 'cloudy',
    '03n': 'cloudy',
    '04d': 'cloudy',
    '04n': 'cloudy',
    '09d': 'rainy',
    '09n': 'rainy',
    '10d': 'rainy',
    '10n': 'rainy',
    '11d': 'storms',
    '11n': 'storms',
    '13d': 'snowing',
    '13n': 'snowing',
    '50d': 'foggy',
    '50n': 'foggy',
  };
  ngOnInit(): void {
    this.store.dispatch(crosscuttingActions.weather());
  }
}
